import { useMemberSettings } from "@hooks/useMemberSettings";
import { localizePhoneNumber, TextField } from "kz-ui-sdk";
import { forwardRef } from "react";
import { MdPhoneAndroid } from "react-icons/md";

type TextFieldProps = React.ComponentProps<typeof TextField>;

interface PhoneFieldProps extends Omit<TextFieldProps, "prefix" | "icon"> {}

const PhoneField = forwardRef<HTMLInputElement, PhoneFieldProps>((props: PhoneFieldProps, ref) => {
  const { classes, value, defaultValue, ...rest } = props;
  const { phonePrefix, showPhoneInputPrefix } = useMemberSettings();

  const localizeValue = (input: TextFieldProps["value"]) =>
    typeof input === "string" ? localizePhoneNumber(input, phonePrefix) : input;

  const localizedDefaultValue =
    value === undefined && typeof defaultValue === "string" ? localizeValue(defaultValue) : defaultValue;

  return (
    <TextField
      {...rest}
      value={value !== undefined ? localizeValue(value) : undefined}
      defaultValue={value === undefined ? localizedDefaultValue : undefined}
      icon={<MdPhoneAndroid className="text-2xl text-content-base" />}
      prefix={showPhoneInputPrefix ? phonePrefix : undefined}
      classes={{
        ...classes,
        "input&": "w-full !px-0 !pl-11 text-start" + (showPhoneInputPrefix ? " !pl-20" : ""),
        "prefixContainer&": showPhoneInputPrefix ? "absolute left-11 top-[10px] text-content-base" : "",
      }}
      ref={ref}
    />
  );
});

PhoneField.displayName = "PhoneField";

export default PhoneField;
